import React from 'react'
import styles from './SegmentedControl.module.css'

const SegmentedControl = ({ options = [], value, onChange, className }) => (
    <div className={`${styles.control} ${className || ''}`}>
        {options.map((opt) => (
            <button
                key={opt.value}
                type="button"
                disabled={opt.disabled}
                title={opt.disabledHint && opt.disabled ? opt.disabledHint : undefined}
                className={`${styles.segment} ${
                    value === opt.value ? styles.active : ''
                } ${opt.disabled ? styles.disabled : ''}`}
                onClick={() => !opt.disabled && onChange(opt.value)}
            >
                {opt.label}
            </button>
        ))}
    </div>
)

export default SegmentedControl
